import { FunctionComponent } from 'react';
import { JsonView, collapseAllNested } from 'react-json-view-lite';
import { useSelector } from 'react-redux';

import { Text } from '@kanda-libs/ks-design-library';

import paymentSelectors from 'store/selectors/payments';

export interface CreditInfoProps {}

const CreditInfo: FunctionComponent<CreditInfoProps> = function () {
  const credit = useSelector(paymentSelectors.getPaymentCredit);

  return (
    <div className="flex flex-col">
      <Text
        text="Credit info:"
        className="mb-6 text-16-20-em text-neutral-800"
      />
      {credit ? <JsonView data={credit} /> : null}
    </div>
  );
};

export default CreditInfo;
